var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVerde({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 52,
    viewBox: "0 0 69 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5549_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1487 0L67.7412 1.68028L68.3373 0H68.9993V2.34648H68.5714V0.455231L67.9277 2.34648H67.562L66.9257 0.455231V2.34648H66.4868V0H67.1487ZM64.1133 0.392313V0H66.0918V0.392313H65.3348V2.34648H64.874V0.392313H64.1133Z",
    fill: "#084E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6516 0.0592041C8.35665 0.0592041 0 8.58646 0 19.1382V52H41.5419C51.8881 52 60.2849 43.432 60.2849 32.8803V0.0592041H18.6516ZM7.91048 43.928V39.5422C7.91048 39.0514 8.10313 38.5807 8.44606 38.2337C8.78899 37.8866 9.2541 37.6917 9.73907 37.6917H20.6484V42.1329C20.6475 42.613 20.4596 43.0734 20.1255 43.4143C19.7915 43.7551 19.3381 43.949 18.8637 43.9539L7.91048 43.928ZM28.3578 43.928C28.4734 43.3282 28.5274 42.718 28.5187 42.107V29.6085H9.69518C9.0827 29.6234 8.47186 29.6791 7.86659 29.7751V28.9867C7.86274 28.261 8.00031 27.5415 8.27143 26.8696C8.54255 26.1977 8.9419 25.5864 9.44664 25.0708C9.95138 24.5552 10.5516 24.1453 11.213 23.8647C11.8744 23.584 12.584 23.4381 13.3012 23.4351H36.3414V39.1203C36.3463 40.377 35.8578 41.5844 34.9835 42.4768C34.1091 43.3693 32.9204 43.874 31.6785 43.8798H28.3505L28.3578 43.928ZM52.3342 32.8803C52.3427 35.4478 51.4631 37.9373 49.8479 39.9173C48.2328 41.8972 45.9839 43.2428 43.4912 43.7207C44.0472 42.2544 44.3359 40.6982 44.3433 39.1277V15.4149H13.3048C11.564 15.4134 9.84058 15.7645 8.23597 16.4475C8.80614 14.0848 10.1415 11.9834 12.0293 10.4781C13.917 8.97291 16.2483 8.15061 18.6516 8.14234H52.3342V32.8803Z",
    fill: "#084E46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5549_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerde);
export default __webpack_public_path__ + "static/media/logo_verde.24aa24c8e6ae94d3de3cd44ddc6fd71e.svg";
export { ForwardRef as ReactComponent };